var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3.25C3 2.2835 3.7835 1.5 4.75 1.5H10.25C10.6642 1.5 11 1.83579 11 2.25C11 2.66421 10.6642 3 10.25 3H4.75C4.61193 3 4.5 3.11193 4.5 3.25V20.75C4.5 20.8881 4.61193 21 4.75 21H10.25C10.6642 21 11 21.3358 11 21.75C11 22.1642 10.6642 22.5 10.25 22.5H4.75C3.7835 22.5 3 21.7165 3 20.75V3.25Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0064 12.75L15.7055 16.2342C15.4207 16.5349 15.4335 17.0096 15.7342 17.2945C16.0349 17.5793 16.5096 17.5665 16.7945 17.2658L21.2945 12.5158C21.5685 12.2265 21.5685 11.7735 21.2945 11.4842L16.7945 6.73419C16.5096 6.43349 16.0349 6.42066 15.7342 6.70554C15.4335 6.99041 15.4207 7.46511 15.7055 7.76581L19.0063 11.25H10.75C10.3358 11.25 10 11.5858 10 12C10 12.4142 10.3358 12.75 10.75 12.75H19.0064Z",
    fill: "#111111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign-out.fe696575.svg";
export { ForwardRef as ReactComponent };